import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core'
import { EnterpriseContextService } from '../../../services/enterprise-context.service'
import { AuthenticationService } from '../../../services/authentication.service'
import { EnterpriseConfig } from '../../../config/enterprise.config'
import { Subscription } from 'rxjs'

@Component({
    selector: 'app-enterprise-page-selector',
    templateUrl: './enterprise-page-selector.component.html',
    styleUrls: ['./enterprise-page-selector.component.scss'],
})
export class EnterprisePageSelectorComponent implements OnInit, OnDestroy {
    @Output() enterpriseChanged = new EventEmitter<string | null>()
    
    availableEnterprises: EnterpriseConfig[] = []
    currentEnterprise: EnterpriseConfig | null = null
    isAllEnterprisesSelected = true
    private subscription: Subscription

    constructor(
        public enterpriseContext: EnterpriseContextService,
        public authService: AuthenticationService
    ) {}

    ngOnInit(): void {
        this.availableEnterprises = this.enterpriseContext.getAvailableEnterprises()
        
        this.subscription = this.enterpriseContext.currentEnterprise$.subscribe((enterprise) => {
            this.currentEnterprise = enterprise
            this.isAllEnterprisesSelected = enterprise === null
        })
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe()
        }
    }

    onEnterpriseSelect(enterpriseKey: string | null): void {
        this.enterpriseContext.setEnterprise(enterpriseKey)
        this.enterpriseChanged.emit(enterpriseKey)
    }

    get canSwitchEnterprise(): boolean {
        return this.enterpriseContext.canSwitchEnterprise
    }

    get isEnterpriseManager(): boolean {
        return this.authService.isEnterpriseManager
    }
}

